import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MedicationRouteNamePipe } from 'src/app/pipes/medication-route-name.pipe';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { FluidsBolusInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-fluids-bolus-item',
    templateUrl: './fluids-bolus-item.component.html',
    styleUrl: './fluids-bolus-item.component.scss',
    imports: [InstructionBoxComponent, ItemContentComponent, MedicationRouteNamePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsBolusItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: FluidsBolusInstructions;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as FluidsBolusInstructions;
	}

	constructor() {
	}
}